export default {
  arrayRemoveDuplicates: function (arrayWithDuplicates) {
    var seen = {}
    return arrayWithDuplicates.filter(function (item) {
      return seen.hasOwnProperty(item) ? false : (seen[item] = true)
    })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/UtilityMethods.js